import React from 'react';
import styles from './LocaleButton.module.scss';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
const LocaleButton = ({ className, handleLanguageChange, locale, selected }) => {
    const [rootClass] = getClassName({
        styles,
        rootClass: 'localeButton',
        modifiers: {
            selected,
        },
        className,
    });
    return locale ? (<div className={rootClass} onClick={() => handleLanguageChange(locale)} aria-label={locale?.translatedName}>
            {locale?.translatedName} ({locale?.cultureRegionCode})
        </div>) : null;
};
export default LocaleButton;
